



























































































































































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountWill } from '@/shared/clients/client-account-will';
import { ClientAccountWillExecutor } from '@/shared/clients/client-account-will-executor';
import { WillType } from '@/shared/types/will-type';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const usersModule = namespace('users');

@Component
export default class ViewWillHistoryItemDialog extends Vue {
    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public will!: ClientAccountWill;
    @Prop({ required: true }) public visible!: boolean;

    @typesModule.Getter('willTypes') private willTypes!: Array<WillType>;

    @usersModule.Getter('users') private users!: Array<User>;

    private isVisible: boolean = this.visible;

    private get orderedWillExecutors(): Array<ClientAccountWillExecutor> {
        return this.will.executors.sort((n1, n2) => {
            if (n1.displayOrder! > n2.displayOrder!) { return 1; }
            if (n1.displayOrder! < n2.displayOrder!) { return -1; }
            return 0;
        });
    }

    private get willTypeDescription(): string {
        const type = this.willTypes.find((t) => t.id === this.will.willTypeId);
        return type == null ? '' : type.value;
    }

    private get createdBy(): string {
        const user = this.users.find((u) => u.id === this.will.createdBy);
        return user == null ? this.will.createdBy! : `${user.firstName == null ? '' : user.firstName} ${user.lastName == null ? '' : user.lastName}`;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private firstOrSubstituteExecutorTypeDescription(executor: ClientAccountWillExecutor): string | null {
        if (executor == null || executor.isFirstOrSubstituteExecutor == null) {
            return null;
        }

        return executor.isFirstOrSubstituteExecutor ? 'Sub Exec' : 'First Exec';
    }

    private soleOrCoExecutorTypeDescription(executor: ClientAccountWillExecutor): string | null {
        if (executor == null || executor.isSoleOrCoExecutor == null) {
            return null;
        }

        return executor.isSoleOrCoExecutor ? 'Co-Exec' : 'Sole Exec';
    }
}
